// @ts-check


/**
 * Decipher each word by word
 * @param {string} saltString
 * @param {string} encipheredString
 * @returns {?string}
 */
function getInvertedLetterFromAlphabetForLetter(saltString, encipheredString) {
    /** @type string */
    const lookupTable = "abcdefghijklmnopqrstuvwxyz0123456789=ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const posLetter = lookupTable.indexOf(saltString);

    if (posLetter == -1) {
        return null;
    }
    const part1 = lookupTable.substring(posLetter, lookupTable.length);
    const part2 = lookupTable.substring(0, posLetter);

    const generatedString = "" + part1 + "" + part2;

    const posLetterToChange = generatedString.indexOf(encipheredString);

    if (posLetterToChange == -1) {
        return null;
    }

    const letterAccordingToAbc = lookupTable.split("")[posLetterToChange];

    return letterAccordingToAbc;
}

/**
 * Decipher server enciphered text
 * @param {string} salt
 * @param {string} text
 * @returns {?string}
 */
export function decipher(salt, text) {

    // convert the string to decrypt into an array
    const arr = text.split("");

    // let's also create an array from our password
    const arrPass = salt.split("");

    // keep control about which letter from the password we use
    let lastPassLetter = 0;

    // this is the final decrypted string
    let decrypted = "";

    // let's start...
    for (let i = 0; i < arr.length; i++) {

        // next letter from the string to decrypt
        const letter = arr[i];

        // get the next letter from the password
        const passwordLetter = arrPass[lastPassLetter];
        // get the decrypted letter according to the password
        const temp = getInvertedLetterFromAlphabetForLetter(
            passwordLetter, letter);
        if (temp) {
            // concat the response
            decrypted += temp;
        } else {
            // if any error, return null
            return null;
        }

        // if our password is too short,
        // let's start again from the first letter
        if (lastPassLetter == (arrPass.length - 1)) {
            lastPassLetter = 0;
        } else {
            lastPassLetter++;
        }
    }
    // return the decrypted string and converted
    // from base64 to plain text
    return window.atob(decrypted);
}
